export default {
  BT_HDP: "แฮนดิแคป l HDP",
  BT_OU: "สูง/ต่ำ l O/U",
  BT_ML: "มันนี่ไลน์",
  BT_1X2: "1X2",
  BT_1X2HDP: "แฮนดิแคป 3 ทาง",
  BT_CS: "ทายผลสกอร์",
  BT_OE: "คี่/คู่",
  BT_DC: "สองโอกาส",
  BT_HTFT: "ครึ่งเวลา/เต็มเวลา",
  BT_FGLG: "ประตูแรก/สุดท้าย",
  BT_TG: "จำนวนประตูทั้งหมด",
  BT_OR: "ทายผลผู้ชนะ",
  BT_ORZ: "ทายผลผู้ชนะ",
  BT_ODD: "คี่",
  BT_EVEN: "คู่",
  BT_ANB: "ไม่มีการวางเดิมพันทีมเยือน",
  BT_BS: "ทั้งสองทีม/หนึ่งทีม/ไม่มีทีมใดที่ทำคะแนนได้",
  BT_CL: "ไม่เสียประตู",
  BT_DNB: "เสมอไม่เดิมพัน",
  BT_DNBH: "ครึ่งแรก เสมอไม่เดิมพัน",
  BT_HNB: "ไม่มีการวางเดิมพันทีมเหย้า",
  BT_TWTN: "ชนะโดยไม่เสียประตู",
  BT_HDPH: "ครึ่งแรก แฮนดิแคป l ครึ่งแรก. HDP",
  BT_OUH: "ครึ่งแรก สูง/ต่ำ l ครึ่งแรก O/U",
  BT_MLH: "ครึ่งแรก มันนี่ไลน์",
  BT_1X2H: "ครึ่งเวลา 1X2",
  BT_1X2HDPH: "ครึ่งแรก แฮนดิแคป 3 ทาง",
  BT_CSH: "ครึ่งแรก ทายผลสกอร์",
  BT_OEH: "ครึ่งแรก คี่/คู่",
  BT_DCH: "ครึ่งเวลา สองโอกาส",
  BT_FGLGH: "ครึ่งแรก ประตูแรก/สุดท้าย",
  BT_TGH: "ครึ่งแรก จำนวนประตูทั้งหมด",
  TB_HDP: "เต็มเวลา แฮนดิแคป",
  TB_OU: "เต็มเวลา สูง/ต่ำ",
  TB_1X2: "เต็มเวลา 1X2",
  TB_OE: "เต็มเวลา คี่/คู่",
  TB_HDPH: "ครึ่งแรก แฮนดิแคป",
  TB_OUH: "ครึ่งแรก สูง/ต่ำ",
  TB_1X2H: "ครึ่งแรก 1X2",
  TB_OEH: "ครึ่งแรก คี่/คู่",
  BT_HDPOU: "แฮนดิแคป & สูง/ต่ำ",
  BT_PARLAY: "มิกซ์ พาร์เลย์",
  BT_FT: "เต็มเวลา",
  BT_1H: "ครึ่งแรก",
  BT_2H: "ครึ่งหลัง",
  BT_FG: "ประตูแรก",
  BT_LG: "ประตูสุดท้าย",
  BT_HFG: "HFG",
  BT_AFG: "AFG",
  BT_HLG: "HLG",
  BT_ALG: "ALG",
  BT_NG: "ไม่มีประตู",
  BT_HY: "เจ้าบ้าน ไม่เสียประตู",
  BT_HN: "เจ้าบ้าน เสียประตู",
  BT_AY: "ทีมเยือน ไม่เสียประตู",
  BT_AN: "ทีมเยือน เสียประตู",
  BT_H: "เจ้าบ้าน",
  BT_A: "ทีมเยือน",
  BT_D: "เสมอ",
  BT_HD_DC: "HD",
  BT_HA_DC: "HA",
  BT_DA_DC: "DA",
  BT_HH: "HH",
  BT_HD: "HD",
  BT_HA: "HA",
  BT_DH: "DH",
  BT_DD: "DD",
  BT_DA: "DA",
  BT_AH: "AH",
  BT_AD: "AD",
  BT_AA: "AA",
  BT_Y: "ใช่",
  BT_N: "ไม่มี",
  BT_LIVE: "สด",
  BT_HT: "ครึ่งแรก",
  BT_DELAYED: "DELAY",
  BT_PEN: "PEN",
  BT_FT1: "เต็มเวลา.1",
  BT_FT2: "เต็มเวลา.2",
  BT_FTX: "เต็มเวลา.X",
  TC_FT1: "1",
  TC_FT2: "2",
  TC_FTX: "X",
  BT_HT1: "ครึ่งเวลา.1",
  BT_HT2: "ครึ่งเวลา.2",
  BT_HTX: "ครึ่งเวลา.X",
  F5_INN_HDP: "F5 INN. HDP",
  F5_INN_OU: "F5 INN. O/U",
  BS_HDP: "เต็มเวลา แฮนดิแคป",
  BS_HDPH: "ครึ่งเวลา แฮนดิแคป",
  BS_OU: "เต็มเวลา สูง/ต่ำ",
  BS_OUH: "ครึ่งเวลา สูง/ต่ำ",
  BS_OE: "เต็มเวลา คี่/คู่",
  BS_OEH: "ครึ่งเวลา คี่/คู่",
  BS_1X2: "เต็มเวลา 1X2",
  BS_1X2H: "ครึ่งแรก 1X2",
  BS_ML: "เต็มเวลา มันนี่ไลน์",
  BS_MLH: "ครึ่งเวลา มันนี่ไลน์",
  BS_1X2HDP: "เต็มเวลา แฮนดิแคป 3 ทาง",
  BS_1X2HDPH: "ครึ่งเวลา แฮนดิแคป 3 ทาง",
  BS_CS: "เต็มเวลา ทายผลสกอร์",
  BS_CSH: "ครึ่งเวลา ทายผลสกอร์",
  BS_DC: "เต็มเวลา สองโอกาส",
  BS_DCH: "ครึ่งเวลา สองโอกาส",
  BS_FGLG: "เต็มเวลา ประตูแรก/สุดท้าย",
  BS_FGLGH: "ครึ่งเวลา ประตูแรก/สุดท้าย",
  BS_TG: "เต็มเวลา จำนวนประตูทั้งหมด",
  BS_TGH: "ครึ่งเวลา จำนวนประตูทั้งหมด",
  BS_ANB: "ไม่มีการวางเดิมพันทีมเยือน",
  BS_HTFT: "ครึ่งเวลา/เต็มเวลา",
  BS_BS: "ทั้งสองทีม/หนึ่งทีม/ไม่มีทีมใดที่ทำคะแนนได้",
  BS_CL: "ไม่เสียประตู",
  BS_DNB: "เสมอไม่เดิมพัน",
  BS_DNBH: "ครึ่งเวลา เสมอไม่เดิมพัน",
  BS_HNB: "ไม่มีการวางเดิมพันทีมเหย้า",
  BS_TWTN: "ชนะโดยไม่เสียประตู",
  BS_OR: "ทายผลผู้ชนะ",
  BS_ORZ: "ทายผลผู้ชนะ"
};
